import { Injectable, InjectionToken, Signal } from '@angular/core';
import { Charity } from 'src/app/core/models/Charity';
import { User, CharityDonor } from 'src/app/core/models/User';
import { Business } from 'src/app/core/models/Business';
import { Donation } from 'src/app/core/models/Donation';
import { CardItem } from 'src/app/core/models/CardItem';
import { FundANeed } from 'src/app/core/models/FundANeed';
import { SegmentCustomEvent } from '@ionic/angular/standalone';

export type CharityDetailRouteContext = 'user' | 'business';

export const CHARITY_DETAIL_ROUTE_CONTEXT: InjectionToken<CharityDetailRouteContext> = new InjectionToken<CharityDetailRouteContext>(
  'CHARITY_DETAIL_ROUTE_CONTEXT',
  { factory: () => 'user' },
);

export interface CharityDetailViewModel {
  charityId: string;
  charity: Charity | null;
  loggedInUser: User | null;
  business: Business | null;
  isBusinessContext: boolean;
  canDonate: boolean;
  guestMode: boolean;

  moneyDonations: Donation[];
  hourDonations: Donation[];
  moneyDonationHistory: Donation[];
  hourDonationHistory: Donation[];
  totalMoneyDonation: number;
  totalHourDonation: number;
  totalRangeMoneyDonation: number;
  totalRangeHourDonation: number;
  totalDonatedMoneyByUser: number;
  totalDonatedMoneyToCharityByUser: number;
  followers: number;
  topDonors: CharityDonor[];

  impactPoints: CardItem[];
  publicAuctions: CardItem[];
  products: CardItem[];
  fanCards: CardItem[];
  fundANeeds: FundANeed[];

  isHourMode: boolean;
  isFollowing: boolean | object;
  isFollowActionLoading: boolean;
  isDonateLoading: boolean;
  imageLoaded: boolean;
  moneyDataLoaded: boolean;
  hourDataLoaded: boolean;
  userDataLoaded: boolean;
  charityDataLoaded: boolean;
  donorsLoaded: boolean;
  expandDonations: boolean;

  selectedSection: 'About Charity' | 'Your Donations';
  timeRangeSum: number;
  timeRangeText: string;

  segmentConfig: { sections: string[]; contentIds: string[]; segmentClass: string };
}

@Injectable()
export abstract class CharityDetailFacade {
  abstract readonly vm: Signal<CharityDetailViewModel>;

  abstract activate(): void;
  abstract refresh(event: CustomEvent): void;
  abstract onToggle(): void;
  abstract onSegmentChanged(event: SegmentCustomEvent): void;
  abstract onScrollSync(section: string): void;
  abstract onTimeRangeSum(value: number): void;
  abstract onTabSelected(timeRange: string): void;

  abstract onDonate(): void;
  abstract onDonateFan(fanId: number): void;
  abstract onFollowCharity(): void;
  abstract presentUnfollowAlert(): void;
  abstract onShare(): Promise<void>;
  abstract onEmailCharity(): void;
  abstract onRequest(): void;
  abstract onSignUpToViewData(): void;

  abstract goToImpactPoints(): void;
  abstract onSelectSeeAllFundANeeds(): void;
  abstract goToFollowers(): void;
  abstract goToAuction(auctionId: number): void;
  abstract onSelectImpactPoint(id: number): void;
  abstract onSelectFan(id: number): void;
  abstract goToAllProducts(): void;
  abstract goToProduct(id: number): void;
  abstract goToDonorProfile(donorId: string): void;
  abstract scrollToDonations(): void;

  abstract toggleDonationHistory(): void;
  abstract setImageLoaded(): void;

  abstract getDonations(): Donation[];
  abstract getTotalDonationsCount(): number;
  abstract formatDollarAmount(value: number, digits?: number): string;
}
